var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricing2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 447,
    viewBox: "0 0 175 447",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_20309)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_65_20309",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -68,
    width: 1294,
    height: 515
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -68,
    width: 1293.25,
    height: 514.5,
    fill: "#270F3A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_65_20309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.893 4.39419C175.538 73.4937 171.222 153.791 126.015 207.027C114.564 220.51 99.2808 230.656 82.4807 236.754M82.4807 236.754C56.8928 246.042 27.7867 245.942 3.34616 233.947C-34.8912 215.181 -66.7191 179.376 -61.4145 133.117C-58.6496 109.006 -46.218 89.618 -21.7297 88.5756C15.6828 86.983 50.2074 131.12 63.3877 164.221C72.5006 187.106 78.8458 211.592 82.4807 236.754ZM82.4807 236.754C95.2526 325.17 74.5601 421.948 22.8853 487.086",
    stroke: "#FF8C66",
    strokeWidth: 8,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_20309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 447,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricing2);
export default __webpack_public_path__ + "static/media/pricing_2.36f46f34baf97849a2a21b464eb23f18.svg";
export { ForwardRef as ReactComponent };